import React, { Component } from 'react';
import Breadcrumbs from '../../common/Breadcrumbs';
import './style.css';
import ArchiveListWO from '../ArchiveListWO';
import ArchiveListQuotes from '../ArchiveListQuotes';
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import hasAccess from "../../helpers/permissionChecker";
import { fetchShops } from "../../api/shops";
import { push } from "react-router-redux";
import { changeModalState } from "../../actions/modal";
import { deleteObject } from "../../actions/objectToDelete";
import connect from "react-redux/es/connect/connect";

export class Archive extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      activeTab: 0
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render() {
    const workOrderArchiveAccess = hasAccess({ 'permAreaKey': 'workOrder', 'permTypeKey': 'archive' });
    const quoteArchiveAccess = hasAccess({ 'permAreaKey': 'quote', 'permTypeKey': 'archive' })
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'archive', name: 'Archive' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            <span>Archive</span>
            <span className="archive-tabs">
                  <Nav tabs>
                    {workOrderArchiveAccess &&
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === 0 ? 'active' : ''}
                        onClick={() => this.toggle(0)}>
                        Work Orders
                      </NavLink>
                    </NavItem>
                    }
                    {quoteArchiveAccess &&
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === 1 ? 'active' : ''}
                        onClick={() => this.toggle(1)}>
                        Quotes
                      </NavLink>
                    </NavItem>
                    }
                  </Nav>
                </span>
          </div>
          <div className="card-block">
            <TabContent activeTab={this.state.activeTab.toString()}>
              {workOrderArchiveAccess &&
              <TabPane tabId="0"><ArchiveListWO/></TabPane>
              }
              {quoteArchiveAccess &&
              <TabPane tabId="1"><ArchiveListQuotes/></TabPane>
              }
            </TabContent>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Archive);




// WEBPACK FOOTER //
// ./src/containers/Archive/index.js